import { ApiContextType } from '../api-context';
import {
    PortalDetails,
    FetchRequest,
    FetchPortalsResponse,
    Package,
    FetchFederationsResponse,
    FetchMailsResponse,
    UpdatePortalRequest, Tag
} from '../typings';
export const createNewPortal = (api: ApiContextType, name: string) => {
    return api.put('/portal', name)
        .then((res) => {
            if (res.status == 200 || res.status == 204) {
                return res.text().then(t => Promise.resolve(Number(t)));
            }
            return Promise.resolve(0);
        });
}
export const fetchPortals = (api: ApiContextType, request: FetchRequest): Promise<FetchPortalsResponse> => {
    return api.post(`/portals`, request)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchPackagesWithoutDrill = (api: ApiContextType, id: number): Promise<Package[]> => {
    return api.get(`/drill/${id}/not-in-packages`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchPackagesWithDrill = (api: ApiContextType, id: number): Promise<Package[]> => {
    return api.get(`/drill/${id}/in-packages`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchPackages = (api: ApiContextType): Promise<Package[]> => {
    return api.get('/packages')
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        })
}

export const fetchTagsForPackage = (api: ApiContextType, id: number): Promise<Tag[]> => {
    return api.get(`/package/${id}/tags`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        })
}

export const fetchTagsForPortal = (api: ApiContextType, id: number): Promise<Tag[]> => {
    return api.get(`/portal/${id}/tags`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        })
}

export const addDrill = (api: ApiContextType, id: number, request: number[]): Promise<void> => {
    return api.put(`/drill/${id}/add`, request)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const removeDrill = (api: ApiContextType, id: number, request: number[]): Promise<void> => {
    return api.put(`/drill/${id}/remove`, request)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const deleteDrill = (api: ApiContextType, id: number): Promise<void> => {
    return api.del(`/drill/${id}`)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const fetchPortal = (api: ApiContextType, id: number): Promise<PortalDetails> => {
    return api.get(`/portal/${id}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const updatePortal = (api: ApiContextType, id: number, request: UpdatePortalRequest): Promise<void> => {
    return api.post(`/portal/${id}`, request)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const updatePortalSponsor = (api: ApiContextType, id: number, location: string, name: string): Promise<void> => {
    return api.post(`/portal/${id}/sponsor`, { location, name })
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};


export const deletePortalSponsor = (api: ApiContextType, id: number, location: string): Promise<void> => {
    return api.del(`/portal/${id}/sponsor/${location}`)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const fetchPortalAdmins = (api: ApiContextType, id?: string): Promise<string[]> => {
    return api.get(`/portal/${id}/admin`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const addPortalAdmins = (api: ApiContextType, id: string, email: string): Promise<void> => {
    return api.post(`/portal/${id}/admin`, email)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};



